module.exports = __webpack_public_path__ + "media/packs/images/flags/GM-f97157882eec257798f2becd0efc020a.png";